/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 26.05.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ReactDOM from 'react-dom';
import shallowCompare from 'react-addons-shallow-compare';
import moment from 'moment';
import Platform from 'platform';
import Classnames from 'classnames';

import {VelocityComponent} from 'velocity-react';

import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';
import _map from 'lodash/map';
import _throttle from 'lodash/throttle';
import _inRange from 'lodash/inRange';
import _isNull from 'lodash/isNull';

import DivLoader from '../DivLoader';
import Translate from '../Translate';
import EventsRow from './epg-grid-schedule-row';
import ChannelRow from './epg-grid-chanel-row';
import Profile from '../../components/ShowcaseCollection/Profile';

import {EPG_ROW_HEIGHT, positiveOrZero, positiveOrZeroAndLessThan} from '../../utils';
import {OpenProfileFor, SetPlayer} from '../../actions/common/actions-common';
import {ACTIONS} from '../../containers/Player';

class Grid extends Component {
  constructor(props) {
    super(props);

    this._isMobile = false;
    this._deferedState = null;
    this._moveNowTimer = null;
    this._prevSetState = {};
    this._addToTopMax = false;
    this._rowN = null;
    //this._direction = {
    //  v: 0,
    //  h: 0,
    //  speed_v: 0,
    //  speed_h: 0
    //};

    this.state = {
      slowMotion: 0.1,
      speed: 1,
      lastClientPositionX: 0,
      lastClientPositionY: 0,
      topPosition: 0,
      leftPosition: 0,
      isDragging: false,
      pxInMin: 1050 / _get(Config, 'epg.epg_container_window_in_min', 180),
      now: null,
      nowPosition: 0,
      isToday: false,
      maxTop: 0,
      extendedRow: null,
      selectedObj: {}
    };

    this._bindedHandleMouseMove = _throttle(this._handleMouseMove.bind(this), 50);
    this._bindedHandleMouseUp = this._handleMouseUp.bind(this);

    this._bindedHandleTouchMove = _throttle(this._handleTouchMove.bind(this), 16);
    this._bindedHandleTouchMovePrevented = function (e) {
      e.preventDefault();
      e.stopPropagation();

      //this._bindedHandleTouchMove(e);
      return false;
    }.bind(this);

    this._bindedHandleTouchEnd = this._handleTouchEnd.bind(this);
  }

  componentDidMount() {
    let now = moment().unix();
    let isToday = this.props.start < now && this.props.end > now;

    let maxTop = 0;

    if ((_get(this.props, 'schedule.length', 0) < _get(Config, 'epg.epg_container_channels_in_view', 10))) {

      //maxTop = _get(this.props, 'schedule.length', 0) * EPG_ROW_HEIGHT;
      maxTop = 0;
    } else {

      maxTop = (_get(this.props, 'schedule.length', 0) - _get(Config, 'epg.epg_container_channels_in_view', 10) + 1) * EPG_ROW_HEIGHT;
    }

    this.setState({
      isToday: isToday,
      maxTop: maxTop
    });

    if (isToday) {
      this._setToNow();

      this._moveNowTimer = setInterval(this._setToNow, 30 * 1000);
    }

    if (this.props.globalProfile && this.props.globalProfile !== 'epg') {

      this._onExtendEpgRow(null, null);
    }
  }

  componentWillUnmount() {
    if (this.state.isToday && this._moveNowTimer) {
      clearInterval(this._moveNowTimer);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {

    return shallowCompare(this, nextProps, nextState);
  }

  componentWillReceiveProps(newProps) {
    let newState = {};

    if (newProps.fetchInProgress) {
      this._onClose();
    }

    let now = moment().unix();
    let isToday = newProps.start < now && newProps.end > now;
    newState.isToday = isToday;

    let maxTop = 0;

    if ((_get(newProps, 'schedule.length', 0) < _get(Config, 'epg.epg_container_channels_in_view', 10))) {
      maxTop = 0;
    } else {
      maxTop = (_get(newProps, 'schedule.length', 0) - _get(Config, 'epg.epg_container_channels_in_view', 10) + 1) * EPG_ROW_HEIGHT;
    }
    if (this._addToTopMax) maxTop += 270;

    newState.maxTop = maxTop;

    let topPosition = this.state.topPosition;
    let leftPosition = this.state.leftPosition;

    if (!_isEqual(_map(this.props.schedule, 'id'), _map(newProps.schedule, 'id'))) {

      if ((_get(newProps, 'schedule.length', 0) * EPG_ROW_HEIGHT < _get(this.state, 'topPosition', 0))) {
        topPosition = 0;
      }
    }

    if (newProps.start !== this.props.start) {

      leftPosition = 0;
    }

    let isProfileInContainer = topPosition - this._rowN * EPG_ROW_HEIGHT + 690 - 270 - EPG_ROW_HEIGHT;
    if (this._addToTopMax && !_isNull(this._rowN) && isProfileInContainer < 0) {

      topPosition += (-1) * isProfileInContainer;
    }

    newState.topPosition = topPosition;

    if (isToday) {
      let position = -(newProps.start - now) / 60 * this.state.pxInMin;

      if (!this.state.isDragging) {

        newState = {
          ...newState,
          ...{
            leftPosition: leftPosition || position - 525 || 0,
            nowPosition: position || 0,
            now: now
          }
        };
      }

      if (this._moveNowTimer) clearInterval(this._moveNowTimer);
      this._moveNowTimer = setInterval(this._setToNow, 30 * 1000);

    } else {

      newState = {
        ...newState,
        ...{
          leftPosition: leftPosition || 0,
          nowPosition: 0,
          now: null
        }
      };

      if (this._moveNowTimer) clearInterval(this._moveNowTimer);
    }

    this._setState(newState);

    if (newProps.globalProfile && newProps.globalProfile !== 'epg') {

      this._onExtendEpgRow(null, null);
    }
  }

  _setState(state) {
    if (!_isEqual(this._prevSetState, state)) {
      this._prevSetState = state;
      this.setState(state);
    }

    if (state.topPosition >= this.state.maxTop - EPG_ROW_HEIGHT) {
      this.props.onYEnd();
    }
  }

  _handlerClickCapture = (e) => {
    if (this.state.isDragging) {
      e.preventDefault();
      e.stopPropagation();

      this.setState({
        isDragging: false
      });
    }

    return false;
  }

  _handleMouseDown = (e) => {
    e.preventDefault();

    this._setState({
      lastClientPositionX: e.clientX,
      lastClientPositionY: e.clientY
    });

    //this._direction = {
    //  v: 0,
    //  h: 0,
    //  speed_v: 0,
    //  speed_h: 0
    //};

    ReactDOM.findDOMNode(this).addEventListener('mousemove', this._bindedHandleMouseMove, true);
    window.addEventListener('mouseup', this._bindedHandleMouseUp);
  }

  _handleMouseMove(e) {
    if (e.nativeEvent) {
      e.nativeEvent.preventDefault();
      e.nativeEvent.stopPropagation();
    }

    e.preventDefault();
    e.stopPropagation();

    if (this.props.player.container && !this.props.player.isDetached) {

      this.props.SetPlayer({
        ...this.props.player,
        action: ACTIONS.DETACH
      });
    }

    if (e.clientX === this.state.lastClientPositionX && e.clientY === this.state.lastClientPositionY) {
      return;
    }

    let clientX = e.clientX;
    let clientY = e.clientY;
    let deltaX = this.state.lastClientPositionX - clientX;
    let deltaY = this.state.lastClientPositionY - clientY;

    let newValY = this.state.topPosition + deltaY * this.state.speed;
    let newValX = this.state.leftPosition + deltaX * this.state.speed;

    //this._direction = {
    //  h: Sign(deltaX),
    //  v: Sign(deltaY),
    //  speed_h: Math.abs(deltaX),
    //  speed_v: Math.abs(deltaY)
    //};



    this._setState({
      lastClientPositionX: clientX,
      lastClientPositionY: clientY,
      topPosition: (newValY > 0 && newValY < this.state.maxTop) ? newValY : this.state.topPosition + deltaY * this.state.slowMotion,
      leftPosition: (newValX > 0 && newValX < (this.state.pxInMin * 1440 - 1050)) ? newValX : this.state.leftPosition + deltaX * this.state.slowMotion,
      isDragging: true
    });

    return false;
  }

  _handleMouseUp(e) {
    e.preventDefault();

    this._setState({
      topPosition: positiveOrZeroAndLessThan(this.state.topPosition, this.state.maxTop),
      leftPosition: positiveOrZeroAndLessThan(this.state.leftPosition, this.state.pxInMin * 1440 - 1050)
    });

    //this._makeSmooth();

    ReactDOM.findDOMNode(this).removeEventListener('mousemove', this._bindedHandleMouseMove, true);
    window.removeEventListener('mouseup', this._bindedHandleMouseUp);
  }

  _handleTouchStart = (e) => {
    let {touches} = e;
    if (touches && touches.length === 1) {
      let {clientX, clientY} = touches[0];

      //this._direction = {
      //  v: 0,
      //  h: 0,
      //  speed_v: 0,
      //  speed_h: 0
      //};

      ReactDOM.findDOMNode(this).addEventListener('touchmove', this._bindedHandleTouchMovePrevented);
      window.addEventListener('touchend', this._bindedHandleTouchEnd);
      this._isMobile = true;

      this._setState({
        lastClientPositionX: clientX,
        lastClientPositionY: clientY,
        isDragging: true
      });
    }

    return false;
  }

  _handleTouchMove(e) {

    let {touches} = e;
    if (touches && touches.length === 1) {
      let {clientX, clientY} = touches[0];

      let deltaX = this.state.lastClientPositionX - clientX;
      let deltaY = this.state.lastClientPositionY - clientY;

      let newValX = this.state.leftPosition + deltaX;
      let newValY = this.state.topPosition + deltaY;

      //this._direction = {
      //  h: Sign(deltaX),
      //  v: Sign(deltaY),
      //  speed_h: Math.abs(deltaX),
      //  speed_v: Math.abs(deltaY)
      //};

      this._setState({
        lastClientPositionX: clientX,
        lastClientPositionY: clientY,
        leftPosition: (newValX > 0 && newValX < (this.state.pxInMin * 1440 - 1050)) ? newValX : this.state.leftPosition + deltaX * this.state.slowMotion,
        topPosition: (newValY > 0 && newValY < this.state.maxTop) ? newValY : this.state.topPosition + deltaY * this.state.slowMotion,
        isDragging: true
      });
    }

    return false;
  }

  _handleTouchEnd(e) {

    ReactDOM.findDOMNode(this).removeEventListener('touchmove', this._bindedHandleTouchMovePrevented);
    window.removeEventListener('touchend', this._bindedHandleTouchEnd);

    setTimeout(() => {

      this._isMobile = false;
    }, 2000);

    let newState = {};

    let {changedTouches} = e;
    if (changedTouches && changedTouches.length === 1) {
      let {clientX, clientY} = changedTouches[0];


      let deltaX = this.state.lastClientPositionX - clientX;
      let deltaY = this.state.lastClientPositionY - clientY;

      let newValX = this.state.leftPosition + deltaX * this.state.speed;
      let newValY = this.state.topPosition + deltaY * this.state.speed;

      if (this.props.player.container && !this.props.player.isDetached) {

        this.props.SetPlayer({
          ...this.props.player,
          action: ACTIONS.DETACH
        });
      }

      newState = {
        lastClientPositionX: clientX,
        lastClientPositionY: clientY,
        leftPosition: positiveOrZeroAndLessThan(newValX, this.state.pxInMin * 1440 - 1050),
        topPosition: positiveOrZeroAndLessThan(newValY, this.state.maxTop),
        isDragging: false
      };
    }

    this._setState(newState);

    return false;
  }

  _setToNow = () => {
    let now = moment().unix();
    let position = -(this.props.start - now) / 60 * this.state.pxInMin;

    if (!this.state.isDragging && (!this.state.leftPosition || _inRange(position, this.state.leftPosition + 200, this.state.leftPosition + 825))) {

      this._setState({
        leftPosition: position - 525 || 0,
        nowPosition: position || 0,
        now: now
      });
    } else {

      this._setState({
        nowPosition: position || 0,
        now: now
      });
    }
  }

  _setToStart() {

    this._setState({
      topPosition: 0,
      leftPosition: 0,
      nowPosition: 0,
      now: null
    });
  }

  _needToHide(row) {

    return this.state.topPosition - (this.state.selectedObj ? 270 : 0) > ((row + 2) * 72)
      || (this.state.topPosition - (this.state.selectedObj ? 270 : 0) + (_get(Config, 'epg.epg_container_channels_in_view', 10) + 1) * EPG_ROW_HEIGHT) < (row * EPG_ROW_HEIGHT);
  }

  _ScrollUp = () => {
    this._setState({
      topPosition: positiveOrZeroAndLessThan(this.state.topPosition - EPG_ROW_HEIGHT, this.state.maxTop),
    });
  }

  _ScrollDown = () => {
    this._setState({
      topPosition: positiveOrZeroAndLessThan(this.state.topPosition + EPG_ROW_HEIGHT, this.state.maxTop),
    });
  }

  _makeSmooth() {

    for (var i = 0; i < 5; i++) {
      setTimeout(() => {
        this.setState({
          topPosition: positiveOrZeroAndLessThan(this.state.topPosition + this._direction.v, this.state.maxTop),
          leftPosition: positiveOrZero(this.state.leftPosition + this._direction.h, this.state.maxTop)
        });
      }, 40 * (i + 1) + (i + 1) * 10);
    }
  }

  _onAnimationComplete = () => {
    if (!_isNull(this._deferedState)) {
      this.setState(this._deferedState);
      this._deferedState = null;
    }
  }

  _onClose = () => {
    this._addToTopMax = false;
    this._rowN = null;

    this.setState({
      extendedRow: null,
      selectedObj: null
    });
  }

  _onExtendEpgRow = (row, event) => {

    if (!_isNull(this.state.extendedRow) && row !== this.state.extendedRow) {
      this._onClose();

      this._deferedState = {
        extendedRow: row,
        selectedObj: event
      }
    } else {

      this.setState({
        extendedRow: row,
        selectedObj: event
      });
    }

    this._addToTopMax = !_isNull(row);
    this._rowN = row;

    if (row) this.props.OpenProfileFor('epg');
  }

  //_isMobile() {
  //
  //  return ['Android', 'iOS', 'Windows Phone'].indexOf(Platform.os.family) !== -1;
  //}

  _renderChannelsSchedule() {

    return (
      this.props.schedule.map((item, index) => {

        return (
          <EventsRow
            key={'schedule_row_for' + item.id}
            channel_id={item.id}
            row={index}
            end={this.props.end}
            start={this.props.start}
            pxInMin={this.state.pxInMin}
            schedule={item.epg}
            offset={{topPosition: this.state.topPosition, leftPosition: this.state.leftPosition}}
            needToHide={this._needToHide(index)}
            isToday={this.state.isToday}
            now={this.state.now}
            onExtendEpgRow={this._onExtendEpgRow}
            isExtend={this.state.extendedRow === index}
          />
        );
      })
    );
  }

  _renderChannelsList() {

    return (
      this.props.schedule.map((item, index) => {

        return (
          <ChannelRow
            key={'channel_' + _get(item, 'id', Date.now())}
            data-item={'schedule_item_' + item.id}
            channel={item}
            row={index}
            needToHide={this._needToHide(index)}
            onExtendRow={this._onExtendEpgRow}
            isExtend={this.state.extendedRow === index}
          />
        );
      })
    );
  }

  render() {

    if (!this.props.schedule.length) {

      return <div className="epg-full-container noselect crow">
        <DivLoader loading={this.props.fetchInProgress} />
        {!this.props.fetchInProgress && <div className="profile-bigtext"><Translate content="epg.no_data" /></div>}
      </div>;
    }

    let gridCSS = {
      transform: 'translate3d(' + (-1) * parseInt(this.state.leftPosition, 10) + 'px, ' + (-1) * parseInt(this.state.topPosition, 10) + 'px, 0)'
    };

    let gridClasses = Classnames({
      'events-wrapper': true,
      'animate-transform': this._isMobile
    });

    let chanelListCss = {
      transform: 'translate3d(0,' + (-1) * parseInt(this.state.topPosition, 10) + 'px, 0)'
    };

    /**
     * Magic calculation
     * 759 = 69 * 10 + 69
     * 759 = (channel Row height) * (visible Rows) + (channel Row height because of expand)
     * maxTop could be 0
     */
    let profileContainerCSS = {
      transform: 'translate3d(0, ' + (-1) * (parseInt(this.state.topPosition, 10) + 759 / 759 - this.state.extendedRow * EPG_ROW_HEIGHT) + 'px, 0)',
      display: _isNull(this.state.extendedRow) ? 'none' : 'block'
    };

    let animationOnExpand = {
      marginTop: !_isNull(this.state.extendedRow) ? 0 : '-270px',
      marginBottom: !_isNull(this.state.extendedRow) ? '6px' : 0
    };

    return (<div>
      {this.state.topPosition > 10 && !!this.state.maxTop && <div className="radius clearfix channel-row mb-">
        <div className="epg-event" style={{width: '1236px'}}>
          <div className="col bg-black radius crow hover" style={{width: '100%'}} onClick={this._ScrollUp}>
            <i className="ic ic-chevron-up ic-16px"></i>
          </div>
        </div>
      </div>}
      <div id="epg-body" className="epg-full-container noselect">
        <div className={'epg-event-profile' + (this._isMobile ? ' animate-transform' : '')} style={profileContainerCSS}>
          <VelocityComponent animation={animationOnExpand} complete={this._onAnimationComplete} duration={350}>
            <Profile entity={this.state.selectedObj} channel={_get(this.props, 'schedule[' + this.state.extendedRow + ']', {})} onClose={this._onClose} />
          </VelocityComponent>
        </div>
        <div className={'channel-container' + (this._isMobile ? ' animate-transform' : '')} style={chanelListCss}>
          {this._renderChannelsList()}
        </div>
        <div className="schedule-container">
          <DivLoader loading={this.props.fetchInProgress} />
          <div style={{width: (1050 / _get(Config, 'epg.epg_container_window_in_min', 180)) * 1440 - 1050 + 'px'}}>
            <div className={gridClasses}
                 onMouseDown={this._handleMouseDown}
                 onTouchStart={this._handleTouchStart}
                 onClickCapture={this._handlerClickCapture}
                 style={gridCSS}>
              {this.state.isToday && !!this.state.nowPosition && <div id="epg-current-time-line" className="current-time-line" style={{left: parseInt(this.state.nowPosition, 10) + 'px'}}>
                <img src={`/images/${Config.white_skin ? 'white' : 'black'}/epg-arrow.png`} className="current-time-line-arrow" style={{top: parseInt(this.state.topPosition, 10) + 'px'}} />
                <div className="current-time-line-time col p" style={{top: parseInt(this.state.topPosition + 6, 10) + 'px'}}>
                  {moment(this.state.now * 1000).format(_get(Config, 'epg.epg_event_time_format', 'HH:mm'))}
                </div>
              </div>}
              {this._renderChannelsSchedule()}
              {
                this.props.appendInProgress && <div className="blocks-epg radius clearfix channel-row">
                  <div className="epg-channel-row">
                    <div className="epg-event" style={{left: this.state.leftPosition + 'px', width: '1050px', zIndex: 1000}}>
                      <div className="block-cast block-now col bg-black radius">
                        <DivLoader loading={true} />
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
      {this.state.topPosition < this.state.maxTop - EPG_ROW_HEIGHT && <div className="radius clearfix channel-row mt-">
        <div className="epg-event" style={{width: '1236px'}}>
          <div className="col bg-black radius crow hover" style={{width: '100%'}} onClick={this._ScrollDown}>
            <i className="ic ic-chevron-down ic-16px"></i>
          </div>
        </div>
      </div>}
    </div>);
  }
}

//TODO: Wheel & Keys event
Grid.propTypes = {
  schedule: PropTypes.array,
  onYEnd: PropTypes.func,
  fetchInProgress: PropTypes.bool,
  appendInProgress: PropTypes.bool
};

Grid.defaultProps = {
  schedule: [],
  fetchInProgress: false,
  appendInProgress: false
};

export default connect(({common: {player, profile}}) => ({player, globalProfile: profile}), (dispatch) => (bindActionCreators({OpenProfileFor, SetPlayer}, dispatch)))(Grid);



// WEBPACK FOOTER //
// ./src/components/EPGGrid/grid.js